import { type PropsWithChildren, useContext } from 'react';
import styled from '@emotion/styled';
import { useSetAtom } from 'jotai';
import { useTranslation } from 'next-i18next';
import { ModalKeyContext } from 'src/components/Modal';
import ModalLayoutBase, { MobileModalType } from 'src/components/ModalLayout';
import { closeModalAtom } from 'src/stores/modal/atoms';
import { ModalNavButtonType } from 'src/types/Modal';
const ModalLayout = styled(ModalLayoutBase)`
  background-color: transparent !important;
  min-width: unset;
`;
const ModalBody = styled.div`
  flex: 1;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
const Container = styled.div`
  width: 268px;
  min-height: 0;

  display: flex;
  flex-direction: column;
  align-items: center;

  background: ${({
  theme
}) => theme.color.surface2};
  color: ${({
  theme
}) => theme.color.content12};

  border-radius: 16px;
`;
const Description = styled.div`
  flex: 1;

  padding: 24px 24px 16px 24px;

  font-size: 14px;
  font-weight: 400;
  text-align: center;

  display: inline-flex;
  align-items: center;
`;
const Button = styled.button`
  all: unset;
  cursor: pointer;
  box-sizing: border-box;

  flex: 1;
  padding: 12px 16px;

  font-size: 16px;
  color: ${({
  theme
}) => theme.color.primary1};
  background-color: transparent;

  display: flex;
  justify-content: center;
  cursor: pointer;
`;
const ButtonGroup = styled.div`
  width: 100%;

  display: flex;

  border-top: 1px solid ${({
  theme
}) => theme.color.surface4};
`;
interface Props {
  onClose?: () => void;
}
const AlertModal = ({
  children,
  onClose
}: PropsWithChildren<Props>) => {
  const {
    t
  } = useTranslation();
  const modalType = useContext(ModalKeyContext);
  const closeModal = useSetAtom(closeModalAtom);
  const handleClose = () => {
    if (modalType) closeModal(modalType);
    onClose?.();
  };
  return <ModalLayout isDim mobileType={MobileModalType.SCREEN_MODAL} lockBodyScroll closeWhenClickOutside={false} closeWithESC={false} navButtonType={ModalNavButtonType.NONE} mobileNavButtonType={ModalNavButtonType.NONE} data-sentry-element="ModalLayout" data-sentry-component="AlertModal" data-sentry-source-file="index.tsx">
      <ModalBody data-sentry-element="ModalBody" data-sentry-source-file="index.tsx">
        <Container data-sentry-element="Container" data-sentry-source-file="index.tsx">
          <Description data-sentry-element="Description" data-sentry-source-file="index.tsx">{children}</Description>
          <ButtonGroup data-sentry-element="ButtonGroup" data-sentry-source-file="index.tsx">
            <Button onClick={handleClose} data-sentry-element="Button" data-sentry-source-file="index.tsx">{t('COMMON__OK')}</Button>
          </ButtonGroup>
        </Container>
      </ModalBody>
    </ModalLayout>;
};
export default AlertModal;